import { client } from '../client';
import { getData } from '../apiUtils';
import { Endpoints } from '../endpoints';

export const getRequestsCount = async () => client.get(Endpoints.requestsCount).then(getData);
